import React from 'react'

export default function RadioGroup({ name, options, value, onChange }) {
  return (
    <div className="space-y-2">
      {options.map((opt) => (
        <label key={opt.value} className="flex items-center">
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            className="h-4 w-4 text-sky-600 focus:ring-sky-500 border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">{opt.label}</span>
        </label>
      ))}
    </div>
  )
}
